import React, { useEffect, useRef, useState } from 'react';

const logos = [
  'STRATEGIA',
  'CRESCITA', 
  'RISULTATI',
  'DOMINIO',
  'SUCCESSO',
];

const LogoMarquee = () => {
  const viewportRef = useRef(null);
  const groupRef = useRef(null);
  const [isVisible, setIsVisible] = useState(false);
  const [isDocumentVisible, setIsDocumentVisible] = useState(() => document.visibilityState !== 'hidden');
  const [duration, setDuration] = useState('171s');

  useEffect(() => {
    const viewport = viewportRef.current;
    const group = groupRef.current;
    let mounted = true;

    // Keep the original gentle pace (~5 px/s), now over one complete group.
    const measure = () => {
      if (!mounted) return;
      const width = group.getBoundingClientRect().width;
      if (width > 0) setDuration(`${width / 5}s`);
    };
    const updateDocumentVisibility = () => setIsDocumentVisible(document.visibilityState !== 'hidden');
    const intersectionObserver = typeof IntersectionObserver === 'function'
      ? new IntersectionObserver(([entry]) => setIsVisible(entry.isIntersecting))
      : null;
    const resizeObserver = typeof ResizeObserver === 'function'
      ? new ResizeObserver(measure)
      : null;

    if (intersectionObserver) intersectionObserver.observe(viewport);
    else setIsVisible(true);
    if (resizeObserver) resizeObserver.observe(group);
    else window.addEventListener('resize', measure);
    document.addEventListener('visibilitychange', updateDocumentVisibility);
    measure();
    document.fonts?.ready.then(measure);

    return () => {
      mounted = false;
      intersectionObserver?.disconnect();
      resizeObserver?.disconnect();
      window.removeEventListener('resize', measure);
      document.removeEventListener('visibilitychange', updateDocumentVisibility);
    };
  }, []);

  return (
    <section className="bg-[#0b114e] py-8 border-y border-white/5 overflow-hidden">
      {/* Desktop - Static centered */}
      <div className="hidden md:block max-w-[1400px] mx-auto px-6 lg:px-12">
        <div className="flex items-center justify-center flex-wrap gap-8 lg:gap-16">
          {logos.map((logo, index) => (
            <span
              key={index}
              className="text-white/20 font-bold text-sm lg:text-base tracking-[0.3em]"
            >
              {logo}
            </span>
          ))}
        </div>
      </div>
      
      {/* Mobile - Infinite scroll marquee */}
      <div ref={viewportRef} className="md:hidden relative">
        <div
          className="flex w-max animate-marquee whitespace-nowrap"
          style={{
            '--marquee-duration': duration,
            animationPlayState: isVisible && isDocumentVisible ? 'running' : 'paused',
          }}
        >
          {/* Two equal, non-shrinking groups make a -50% translation exactly one set. */}
          {[0, 1].map((groupIndex) => (
            <div
              key={groupIndex}
              ref={groupIndex === 0 ? groupRef : null}
              aria-hidden={groupIndex === 1 ? true : undefined}
              className="flex shrink-0 items-center"
            >
              {logos.map((logo) => (
                <span
                  key={logo}
                  className="text-white/20 font-bold text-sm tracking-[0.3em] mx-8"
                >
                  {logo}
                </span>
              ))}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default LogoMarquee;
